<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{
        title
      }}</v-card-title>
      <v-card-text>
        <v-form v-model="valid" autocomplete="off">
          <v-layout grid-list-md>
            <v-flex md6>
              <v-text-field v-model="item.staff_id" label="社員番号" required />
            </v-flex>
          </v-layout>
          <v-layout grid-list-md>
            <v-flex md12>
              <v-text-field v-model="item.name" label="名前" required />
            </v-flex>
          </v-layout>
          <v-layout grid-list-md>
            <v-flex md12>
              <v-text-field
                v-model="item.email"
                label="E-mail"
                required
                autocomplete="off"
              />
            </v-flex>
          </v-layout>
          <v-layout grid-list-md v-if="action == 'add'">
            <v-flex md8>
              <v-text-field
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                :type="showPassword ? 'text' : 'password'"
                label="初期パスワード"
                hint="８桁以上"
                v-model="item.first_password"
                class="input-group--focused"
                @click:append="showPassword = !showPassword"
                autocomplete="off"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout grid-list-md>
            <v-flex md6>
              <v-select
                :items="userStatusOptions"
                label="有効・無効"
                v-model="item.status"
              />
            </v-flex>
          </v-layout>
          <v-layout grid-list-md>
            <v-flex md9>
              <v-select
                :items="teamsArray"
                label="チーム"
                v-model="item.team_name"
              />
            </v-flex>
          </v-layout>

          <v-layout grid-list-md>
            <v-flex md9>
              <v-select
                :items="rolesArray"
                label="ユーザー種別"
                v-model="item.user_type"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout grid-list-md>
            <v-flex md7>
              <v-select
                :items="workTypesArray"
                label="勤務種別"
                v-model="item.work_type"
                required
              />
            </v-flex>
            <v-flex md3 v-if="item.work_type == '一般'">
              <v-checkbox
                v-model="item.few_work_days"
                :label="`勤務日時少`"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <div v-if="item.work_type == '一般'">
            <v-layout
              align-center
              justify-start
              row
              fill-height
              class="table-row"
            >
              <v-flex md3>一週間の勤務日数</v-flex>
              <v-flex md3>
                <v-text-field
                  v-model.number="item.work_days_per_week"
                  suffix="日"
                  min="1"
                  max="7"
                  type="number"
                />
              </v-flex>
              <v-flex md6> * 空白の場合は5日として扱います。 </v-flex>
            </v-layout>
            <v-layout
              align-center
              justify-start
              row
              fill-height
              class="table-row"
            >
              <v-flex md3>月の在宅上限日数</v-flex>
              <v-flex md3>
                <v-text-field
                  v-model.number="item.max_home_work_days"
                  suffix="日"
                  min="0"
                  max="31"
                  type="number"
                />
              </v-flex>
            </v-layout>
            <v-layout
              align-center
              justify-start
              row
              fill-height
              class="table-row"
            >
              <v-flex md3>一日の標準時間</v-flex>
              <v-flex md9>
                <input-time
                  :isBy10Minutes="true"
                  v-model="item.predefined_time"
                />
              </v-flex>
            </v-layout>
            <v-layout
              align-center
              justify-start
              row
              fill-height
              class="table-row"
            >
              <v-flex md3>基本給</v-flex>
              <v-flex md3>
                <v-text-field
                  v-model.number="item.base_salary"
                  suffix="円"
                  min="0"
                  type="number"
                  required
                />
              </v-flex>
            </v-layout>
          </div>
          <v-layout grid-list-md>
            <v-flex md6>
              <v-select
                v-model="item.commuting_allowance_type"
                label="交通費種別"
                :items="commutingAllowanceTypes"
              />
            </v-flex>
          </v-layout>
          <v-layout grid-list-md>
            <v-flex md6>
              <v-text-field
                v-if="item.work_type == '一般'"
                v-model.number="item.base_salary"
                suffix="円"
                label="基本給"
                min="0"
                type="number"
                required
              />
              <v-text-field
                v-if="item.work_type == '時給'"
                v-model.number="item.hourly_base_salary"
                suffix="円"
                label="時給"
                min="0"
                type="number"
                required
              />
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">キャンセル</v-btn>
        <v-btn v-if="action == 'add'" @click="addUser">追加</v-btn>
        <v-btn v-if="action == 'update'" @click="updateUser">更新</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import InputTime from "@/components/inputLargeTime";
import { workTypesArray } from "@/master/users.js";
import { teamsArray, rolesArray, userStatusOptions } from "@/master/users.js";

var moment = require("moment-timezone");
moment.tz.setDefault("Asia/Tokyo");

export default {
  components: {
    InputTime,
  },
  props: ["item", "action"],
  data() {
    return {
      workTypesArray: workTypesArray,
      teamsArray: teamsArray,
      rolesArray: rolesArray,
      valid: false,
      name: "",
      nameRules: [(v) => !!v || "必須事項です"],
      email: "",
      emailRules: [
        (v) => !!v || "必須事項です",
        (v) => /.+@.+/.test(v) || "E-mailの形式ではありません。",
      ],
      date: null,
      menu: false,
      showPassword: false,
      commutingAllowanceTypes: ["月額", "日額"],
      userStatusOptions: userStatusOptions,
    };
  },
  computed: {
    title() {
      return "ユーザー情報" + (this.action == "add" ? " 新規追加" : " 更新");
    },
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    addUser() {
      // 在宅可能日数が空白の場合は0にする
      if (!this.item.max_home_work_days) {
        this.item.max_home_work_days = 0;
      }
      this.$emit("createItem", this.item);
    },
    updateUser() {
      // 在宅可能日数が空白の場合は0にする
      if (!this.item.max_home_work_days) {
        this.item.max_home_work_days = 0;
      }
      this.$emit("updateItem", this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


